import * as signalR from "@microsoft/signalr";
import { Addchatlist } from 'Utils/chataddapi';
import { uriGid, ParticipantModel, ParticipantInfo } from 'Utils/participantInfo';

export const connection = new signalR.HubConnectionBuilder()
    .withUrl("/hub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
    }).withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
            if (retryContext.elapsedMilliseconds < 120000) {
                // If we've been reconnecting for less than 60 seconds so far,
                // wait between 0 and 10 seconds before the next reconnect attempt.
                return Math.random() * 10000;
            } else {
                // If we've been reconnecting for more than 60 seconds so far, stop reconnecting.
                return null;
            }
        }
    })
    .build();



//let uname: string;
//uname = "";

//export function setUname(s_uname: string) {
//    uname = s_uname;
//}

const modelone: ParticipantInfo = ParticipantModel();
connection.on("sendGroupMsg", (message: string, username: string, userid: number, type: string, Candidate: boolean) => {

    console.log("CG :: " + uname);
    const isShowAll = Candidate ? true : false;

    //alert(isShowAll);
    if (username != uname) {
        if (fromSetValue) {
            fromSetValue = false;
        }

        if (type == "chat" && ((uRole == "Candidate" && Candidate == true) || uRole == "Interviewer" || uRole == "Spoc")) {
            if (message != "") {
                const tbMessage: HTMLInputElement | null = document.querySelector("#tbMessage");
                const divMessages: HTMLDivElement | null = document.querySelector("#divMessages");
                const m = document.createElement("div");
                let time = "";
                time = new Date().getHours() + ":" + new Date().getMinutes();
                let Datetime = new Date();
                Datetime = new Date();
                //chatL.push({ time: time, message: message, username: username, userId: userid, date_time: Datetime });
                Addchatlist(time, message, username, userid, Datetime, isShowAll);
                m.innerHTML = `<div class="message-author">${username}<span style="font-weight: 100;">${" " + time}</span></div><div class="ChatDiv">${message}</div>`;

                if (tbMessage != null && divMessages != null) {

                    if (uRole == "Candidate" && Candidate == false) {

                    }
                    else {
                        //tbMessage.value = ""
                        divMessages.appendChild(m);
                        divMessages.scrollTop = divMessages.scrollHeight;
                    }
                }

                if (commandPanelActive != "Chat") {
                    ShowHideBadge("chat","");
                }
                
            }
        }
        else if (type == "drp") {
            const items = localStorage.getItem(message);
            (document.getElementById("lstLanguages_ListOfLanguages") as HTMLInputElement).value = message;

            LanguageNameRun = message;
            if (message == 'c') {
                message = 'c_cpp';
            } else if (message == 'c#') {
                message = 'csharp';
            } else if (message == 'c#') {
                message = 'csharp';
            }
            else if (message == 'python3') {
                message = 'python';
            }
            else if (message == 'pas fpc') {
                message = 'pascal';
            }

            let ace: any = "";
            ace = require('ace-builds/src-noconflict/ace');
            let editor: any = "";
            editor = ace.edit('editor');
            editor.getSession().setUseWorker(false);
            editor.setShowPrintMargin(false);
            editor.setReadOnly(false);
            editor.setValue(items);
            editor.gotoLine(1, 0);
            editor.getSession().setMode('ace/mode/' + message);
            editor.session.setMode("ace/mode/" + message);
        }
        else if (type == "code" || type == "CInput" || type == "Input" || type == "Output") {
            let ace: any = "";
            ace = require('ace-builds/src-noconflict/ace');
            let editorId = "";

            if (type == "CInput") {
                editorId = 'CInputeditorsection';
            }
            if (type == "Input") {
                editorId = 'Inputeditor';
            }
            if (type == "Output") {
                editorId = 'Outputeditor';
            }
            if (type == "code") {
                editorId = 'editor';
            }

            let editor: any = "";
            editor = ace.edit(editorId);

            editor.setValue(message);

        }
        else if (type == "ps") {
            if (commandPanelActive != "ProblemStatement") {
                ShowHideBadge("problemstatement","");
            }
            qText = message;
            (document.getElementById("questiontext") as HTMLInputElement).value = message;

        }

    }
    else {
        fromSetValue = true;
    }
});

connection.start().catch((err) => document.write(err));

//if (connection.state == "Disconnected") {
//    connection = new signalR.HubConnectionBuilder()
//        .withUrl("/hub", {
//            skipNegotiation: true,
//            transport: signalR.HttpTransportType.WebSockets
//        })
//        .build();

//    setTimeout(function () {
//        connection.start().catch((err) => document.write(err));
//    }, 5000);
//}
//connection.disconnected(function () {
//     // Restart connection after 5 seconds.
//});

const ShowHideBadge = (id:string,display:string) => {

    switch (id) {
        case "chat":

            let badgeC = document.getElementById("chatBadge") as HTMLSpanElement;
            badgeC = document.getElementById("chatBadge") as HTMLSpanElement
            badgeC.style.display = display;

            break;
        case "problemstatement":

            let badgeP = document.getElementById("problemStatementBadge") as HTMLSpanElement;
            badgeP = document.getElementById("problemStatementBadge") as HTMLSpanElement;
            badgeP.style.display = display;

            break;
        
      
    }

}

export function send(message: string, type: string,Candidate : boolean) {

   

    if (type == "chat") {
        if (message != "") {
            const isShowAll = Candidate ? true : false;
            const tbMessage: HTMLInputElement | null = document.querySelector("#tbMessage");
            const divMessages: HTMLDivElement | null = document.querySelector("#divMessages");
            const m = document.createElement("div");
            m.style.textAlign = "right";
            let time = "";
            time = new Date().getHours() + ":" + new Date().getMinutes();
            let DateTime = new Date();
            DateTime = new Date();
            //var chatL[];
            //let chatL = [];
            //chatL.push({ time: time, message: message, username: username.toString(), userId: userid, date_time: DateTime });
            Addchatlist(time, message, username, userid, DateTime, isShowAll);
            m.innerHTML = `<div class="message-author">${username}<span style="font-weight: 100;">${" " + time}</span></div><div class="ChatDiv" style="margin-left: auto;">${message}</div>`;
            if (tbMessage != null && divMessages != null) {
                tbMessage.value = ""
                divMessages.appendChild(m);
                divMessages.scrollTop = divMessages.scrollHeight;
            }
        }
    }
    //connection.send("RemoveFromGroup", uriGid);
    if (uriGid)
        MessageGroup(uriGid, username, userid, message, type, Candidate);

}

export function MessageGroup(uriGid: string, username: string, userid: number, message: string, type: string,Candidate:boolean) { 
    console.log("COGBEE ConnectionState " + connection.state);

    //if (connection.state == "Disconnected") {
    //    connection.send("RemoveFromGroup", uriGid);

    //    connection.stop();

    //    console.log("COGBEE ConnectionState try to connect");

    //    connection = new signalR.HubConnectionBuilder()
    //        .withUrl("/hub", {
    //            skipNegotiation: true,
    //            transport: signalR.HttpTransportType.WebSockets
    //        })
    //        .build();

        
    //    connection.start().catch((err) => document.write(err));

    //    setTimeout(function () {

    //        console.log("COGBEE ConnectionState Set timeout called");
            
            
    //        connection.send("MessageGroup", uriGid, username, userid, message, type, Candidate);

    //        connection.send("AddToGroup", uriGid);

    //    }, 10000);


    //} else {

        try {
            connection.send("MessageGroup", uriGid, username, userid, message, type, Candidate);
        }
        catch (err) {

            //console.log("TRY COGBEE ConnectionState " + connection.state);
            
            //connection.send("RemoveFromGroup", uriGid);

            

            //console.log("COGBEE ConnectionState try to connect");

            //connection = new signalR.HubConnectionBuilder()
            //    .withUrl("/hub", {
            //        skipNegotiation: true,
            //        transport: signalR.HttpTransportType.WebSockets
            //    })
            //    .build();


            //connection.start().catch((err) => document.write(err));

            //setTimeout(function () {

            //    console.log("COGBEE ConnectionState Set timeout called 2");


            //    connection.send("MessageGroup", uriGid, username, userid, message, type, Candidate);

            //    connection.send("AddToGroup", uriGid);

            //}, 10000);

            //connection.send("AddToGroup", uriGid);

            //connection.send("MessageGroup", uriGid, username, userid, message, type, Candidate);
        }
   // }
}

export function SetInput(from: string, id: string, Candidate: boolean) {

    if (!(id == "questiontext" && modelone.role == "Candidate")) {
        if (window.fromSetValue) {


            let val = "";
            val = (document.getElementById(id) as HTMLInputElement).value

            //  console.log("SetInput::" + "A");

            //if (!connection) {
            //    connection;

            //    AddToGroupSignalR();

            //}

            send(val, from, Candidate);
        }
        else {
            window.fromSetValue = true;
        }
    }


}

//function AddToGroupSignalR() {
//    connection.send("AddToGroup", uriGid);
//}

export { ShowHideBadge };